<template>
  <div class="dashboard-content">
    <!-- Card Relatório de Expedientes -->
    <div class="small-card" @click="chamarRelatorio">
      <div class="card-icon">🖨️</div>
      <div class="card-title">Relatório Registros De Expedientes</div>
      <div class="card-description">
        <p>Registro completo das atividades dos funcionários durante o expediente.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DashboardPage',
  data() {
    return {
      // Sem dados por enquanto
    }
  },
  methods: {
    chamarRelatorio() {
      // Chamar o relatório - pode ser para uma página específica ou abrir em nova janela
      console.log('Chamando relatório de expedientes')
      // Por enquanto, vamos para a página de relatórios
      this.$router.push('/menu/relatorios')
    }
  }
}
</script>

<style scoped>
.dashboard-content {
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 64px);
}

/* Small Card */
.small-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  padding: 32px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  max-width: 400px;
  width: 100%;
}

.small-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
}

.small-card .card-icon {
  font-size: 3rem;
  margin-bottom: 16px;
  display: block;
}

.small-card .card-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 12px;
}

.small-card .card-description {
  color: #64748b;
  font-size: 0.95rem;
  line-height: 1.5;
}

.small-card .card-description p {
  margin: 0;
}
</style>
